export default "__VITE_ASSET__BFiIqMlj__"